import React, { FC } from 'react';

import { Box, HStack, Text } from '@chakra-ui/react';

import { alertStatusColors } from 'containers/Findings/AlertDrawer/Components/Individual/utils';

interface IAlertStatus {
  status: string;
  count?: number;
}

export const AlertStatus: FC<IAlertStatus> = props => {
  const { status, count } = props;
  return (
    <HStack spacing={1}>
      <Box
        borderRadius={2}
        boxSize={3}
        bg={
          alertStatusColors[status?.toLowerCase()?.replace(' ', '')] ?? '#000'
        }
      />
      <HStack spacing={1}>
        <Text>{status}</Text>
        {count && <Text>({count})</Text>}
      </HStack>
    </HStack>
  );
};
